import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FaLink, FaMinus } from 'react-icons/fa';
import Button from '../../elements/Button';
const styles = {
    button: { width: '16px', height: '16px', padding: 0 },
    icon: { fontSize: 9, margin: 'auto' },
};
export function AssignmentActionsButtons(props) {
    const { isActive, onAssign, onUnAssign, x = 0, y = 5, className = 'target', ...otherProps } = props;
    return (_jsxs("foreignObject", { width: "16px", height: "34px", x: x, y: y, className: className, "data-no-export": "true", children: [_jsx(Button, { theme: "success", style: styles.button, onClick: onAssign, ...otherProps, children: _jsx(FaLink, { style: styles.icon }) }), isActive && (_jsx(Button, { theme: "danger", style: { ...styles.button, marginTop: '2px' }, onClick: onUnAssign, ...otherProps, children: _jsx(FaMinus, { style: styles.icon }) }))] }));
}
